import React, {useState} from 'react';
import logo from "../assetes/logo.png";
import ReactSignatureCanvas from 'react-signature-canvas';
import { FaRepeat } from "react-icons/fa6";
import { FaCheck } from "react-icons/fa";
import { request } from "../utils/request";
import { toast } from 'react-toast';
import { accidentAction } from '../redux/slices/accidentSlice';
import { useDispatch, useSelector } from 'react-redux';
import { ClipLoader } from 'react-spinners';
import { useNavigate } from 'react-router-dom';

const AddInfoAuftrag = ({pageState, setPageState}) => {
  const [showOtherInput, setShowOtherInput] = useState(false);
  const options = [
    "Geparkt",
    "Vorfahrt missachtet",
    "Auffahrunfall",
    "Spurwechselunfall",
    "Abbiegeunfall",
    "Überholunfall",
    "Rückwärtsfahren",
    "Einparkunfall",
    "Kreuzungsunfall",
    "Unfall mit Fußgänger oder Radfahrer",
    "Wildunfall",
    "Unfall durch Glätte oder Witterung",
    "Technischer Defekt",
    "Unfallflucht",
    "Anderes ..."
  ];
  // const handleSelectChange = (e) => {
  //   const value = e.target.value;
  //   setShowOtherInput(value === "Anderes ...");
  //   handleInputChange({ target: { name: "damagePath", value } });
  // };
  const handleSelectChange = (e) => {
    const value = e.target.value;
    setShowOtherInput(value === "Anderes ...");
    handleInputChange({ target: { name: "damagePath", value } });
  };
  
  const handleInputChangeSelect = (e) => {
    const { name, value } = e.target;
    if (name === 'damagePath' && value === "") {
      // تعيين قيمة افتراضية إذا كان الحقل فارغًا
      setFormData({ ...formData, [name]: "Keine Angabe" });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const [formData, setFormData] = useState({
    kundenName: '',
    kundenKem: '',
    email: '',
    definition: '',
    company: '',
    damagesRepaired: '',
    damagesNotRepaired: '',
    accidentSite: '',
    damagePath: '',
    tax: '',
    street: '',
    bank: '',
    witness: '',
    oneNote: '',
    oneComment: '',
    status: '',
    lawyer: {
      type: '',
  },
    legal: {
      type: '',
  },
    scheckheft: '',
    azPolizei: '',
    image:null
});
const dispatch = useDispatch()
const {createLoading} = useSelector(state => state.accident)

    const [sign, setSign] = useState();
            const [url, setUrl] = useState();
            const handelClear = () => {
                sign.clear('');
                setUrl('');
                setFormData(prevFormData => ({
                  ...prevFormData,
                  image: null // Set the File object in formData
              }));
            }
            const handelGenerate = () => {
              const imageData = sign.getTrimmedCanvas().toDataURL('image/png');
              fetch(imageData)
                  .then(res => res.blob())
                  .then(blob => {
                      const file = new File([blob], 'signature.png', { type: 'image/png' });
                      setFormData(prevFormData => ({
                          ...prevFormData,
                          image: file // Set the File object in formData
                      }));

                      formData.image=file
          
                      // Create a link to download the image
                      const url = URL.createObjectURL(blob);
                      const a = document.createElement('a');
                      a.href = url;
                      a.download = 'signature.png';
                      document.body.appendChild(a);
                      a.click();
                      document.body.removeChild(a);
                      URL.revokeObjectURL(url); // Cleanup
                  });
          }


          const handleInputChange = (e) => {
            const { name, value } = e.target;
            if (name === 'status') {
              setFormData({ ...formData, status: value });
          } else if (name === 'lawyer.type') {
              setFormData({ ...formData, lawyer: { ...formData.lawyer, type: value } });
          } else if (name === 'legal.type') {
              setFormData({ ...formData, legal: { ...formData.legal, type: value } });
          } else if (name === 'legal.legalKind') {
              setFormData({ ...formData, legal: { ...formData.legal, legalKind: value } });
          } else if (name === 'lawyer.lawyerKind') {
              setFormData({ ...formData, lawyer: { ...formData.lawyer, lawyerKind: value } });
          }else {
                 setFormData({ ...formData, [name]: value });
          }
          if (!formData.damagePath) {
            setFormData({ ...formData, damagePath: " " });
          }
        };


  const navigate = useNavigate();
  const handleNext = async (e) => {
    e.preventDefault();
  
    // تحقق من أن damagePath غير فارغ
    if (!formData.damagePath) {
      toast.error("Bitte wählen Sie einen Schadenhergang aus oder geben Sie eine andere Option ein.");
      return;
    }
  
    if (pageState === 0) {
      try {
        const token = sessionStorage.getItem("token");
        const formDataToSend = new FormData();
        formDataToSend.append("image", formData["image"]);
  
        for (const key in formData) {
          if (typeof formData[key] === 'object' && formData[key] !== null) {
            for (const subKey in formData[key]) {
              formDataToSend.append(`${key}[${subKey}]`, formData[key][subKey]);
            }
          } else {
            formDataToSend.append(key, formData[key]);
          }
        }
  
        dispatch(accidentAction.setCreateLoading(true));
  
        const response = await request.post('/accidents', formDataToSend, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
          }
        });
  
        dispatch(accidentAction.setCreateLoading(false));
        console.log('Response:', response.data);
        dispatch(accidentAction.setLastAccident(response.data));
        navigate("/");
      } catch (error) {
        toast.error(error.response?.data?.message || "Ein Fehler ist aufgetreten.");
        console.error('Error sending data:', error);
        dispatch(accidentAction.setCreateLoading(false));
      }
    }
  };

  
  
  const user = JSON.parse(sessionStorage.getItem("user"));


  return (
    <div className='flex flex-col w-full h-screen overflow-y-auto hidden-scrollbar px-2 md:px-0'>
      <div className="pl-2 md:pl-5 flex flex-col md:flex-row justify-between w-full pt-2 items-center">
        <div>
          <h1 className="font-montserrat text-xl md:text-2xl font-bold">Neuen Auftrag erstellen</h1>
        </div>
        <div className="flex items-center mt-2 md:mt-0">
          <div className="text-center md:text-right">
            <h4 className="text-sm">{user.username}</h4>
            <p className="text-xs text-gray-600">{user.role}</p>
          </div>
          <div className="w-10 h-10 md:w-12 md:h-12 rounded-full border border-gray-800 ml-2">
            <img src={user.profilePhoto?.url} alt="img-pro" className="w-full h-full rounded-full" />
          </div>
        </div>
      </div>
      <div className="border-b border-black w-full mt-3"></div>

      <div className="bg-gray-100 p-4 md:p-8">
        <h1 className="text-lg md:text-2xl font-bold mb-4">Füllen Sie bitte folgende Informationen</h1>
        <form className="flex flex-col space-y-4">
          {/* جميع الحقول الأساسية */}
          {[
            ['Kunden Name', 'kundenName'],
            ['Kunden Kennzeichen', 'kundenKem'],
            ['Kennzeichen von Gegner', 'definition'],
            ['Name/Firma von Gegner', 'company'],
            ['Reparierter Vorschaden', 'damagesRepaired'],
            ['Altschaden vor den Unfall', 'damagesNotRepaired'],
            ['Unfallort', 'accidentSite'],
            ['VORSTEUER', 'tax'],
            ['Straße', 'street'],
            ['BANKVERBINDUNG', 'bank'],
            ['Email', 'email'],
            ['Zeugen Kontaktdaten', 'witness'],
          ].map(([label, name]) => (
            <div key={name} className="flex flex-col md:flex-row md:items-center w-full">
              <label className="font-bold w-full md:w-1/4 mb-1 md:mb-0">{label}:</label>
              <input
                name={name}
                value={formData[name]}
                onChange={handleInputChange}
                required
                type="text"
                className="w-full md:w-3/4 border border-gray-300 bg-[#c8e8ef] rounded-md p-2 focus:outline-none"
                autocomplete="off"
              />
            </div>
          ))}

          {/* Schadenhergang Section */}
          <div className="flex flex-col w-full">
            <label className="font-bold w-full mb-2">Schadenhergang</label>
            <div className="w-full">
              <select
                name="damagePath"
                value={showOtherInput ? "Anderes ..." : formData.damagePath}
                onChange={handleSelectChange}
                required
                className="w-full border border-gray-300 bg-[#c8e8ef] rounded-md p-2 focus:outline-none"
              >
                {options.map((option, index) => (
                  <option key={index} value={option}>{option}</option>
                ))}
              </select>
              {showOtherInput && (
                <input
                  type="text"
                  name="damagePath"
                  value={formData.damagePath === "Anderes ..." ? "" : formData.damagePath}
                  onChange={handleInputChange}
                  className="w-full border border-gray-300 bg-[#c8e8ef] rounded-md mt-2 p-2 focus:outline-none"
                  placeholder="Bitte geben Sie eine andere Option ein"
                  required
                />
              )}
            </div>
          </div>

          {/* Status Section */}
          <div className="flex flex-col w-full">
            <label className="font-bold w-full mb-2">Status</label>
            <div className="flex flex-col md:flex-row space-y-2 md:space-y-0 md:space-x-4">
              {['Finanziert', 'Kauf', 'Leasing'].map((status) => (
                <label key={status} className="inline-flex items-center">
                  <input
                    type="radio"
                    name="status"
                    value={status}
                    checked={formData.status === status}
                    onChange={handleInputChange}
                    className="text-blue-500 focus:ring-blue-400"
                  />
                  <span className="ml-2 font-[700]">{status}</span>
                </label>
              ))}
            </div>
          </div>

          {/* Lawyer Section */}
          <div className="flex flex-col w-full">
            <label className="font-bold w-full mb-2">Rechtsanwalt</label>
            <div className="flex flex-col space-y-2 md:space-y-0 md:flex-row md:space-x-4">
              <label className="inline-flex items-center">
                <input
                  type="radio"
                  name="lawyer.type"
                  value="Europa"
                  checked={formData.lawyer.type === "Europa"}
                  onChange={handleInputChange}
                  className="text-blue-500 focus:ring-blue-400"
                />
                <span className="ml-2 font-[700]">Europa</span>
              </label>
              <div className="flex flex-col md:flex-row items-center space-y-2 md:space-y-0 md:space-x-2">
                <label className="inline-flex items-center">
                  <input
                    type="radio"
                    name="lawyer.type"
                    value="andere"
                    checked={formData.lawyer.type === "andere"}
                    onChange={handleInputChange}
                    className="text-blue-500 focus:ring-blue-400"
                  />
                  <span className="ml-2 font-[700]">andere:</span>
                </label>
                <input
                  type="text"
                  name="lawyer.lawyerKind"
                  className="border border-gray-300 bg-[#c8e8ef] rounded-md p-2 focus:outline-none"
                  disabled={formData.lawyer.type !== "andere"}
                  value={formData.lawyer.lawyerKind}
                  onChange={handleInputChange}
                />
              </div>
            </div>
          </div>

          {/* Legal Section */}
          <div className="flex flex-col w-full">
            <label className="font-bold w-full mb-2">Rechtsschutz</label>
            <div className="flex flex-col space-y-2 md:space-y-0 md:flex-row md:space-x-4">
              <label className="inline-flex items-center">
                <input
                  type="radio"
                  name="legal.type"
                  value="Nein"
                  checked={formData.legal.type === "Nein"}
                  onChange={handleInputChange}
                  className="text-blue-500 focus:ring-blue-400"
                />
                <span className="ml-2 font-[700]">Nein</span>
              </label>
              <div className="flex flex-col md:flex-row items-center space-y-2 md:space-y-0 md:space-x-2">
                <label className="inline-flex items-center">
                  <input
                    type="radio"
                    name="legal.type"
                    value="ja"
                    checked={formData.legal.type === "ja"}
                    onChange={handleInputChange}
                    className="text-blue-500 focus:ring-blue-400"
                  />
                  <span className="ml-2 font-[700]">ja: Versicherungsnummer</span>
                </label>
                <input
                  type="text"
                  name="legal.legalKind"
                  className="border border-gray-300 bg-[#c8e8ef] rounded-md p-2 focus:outline-none"
                  disabled={formData.legal.type !== "ja"}
                  value={formData.legal.legalKind}
                  onChange={handleInputChange}
                />
              </div>
            </div>
          </div>

          {/* AZ POLIZEI Section */}
          <div className="flex flex-col w-full">
            <label className="font-bold w-full mb-2">UNFALLBERICHT/ AZ POLIZEI</label>
            <div className="flex flex-col md:flex-row space-y-2 md:space-y-0 md:space-x-4">
              {['Nein', 'ja'].map((value) => (
                <label key={value} className="inline-flex items-center">
                  <input
                    type="radio"
                    name="azPolizei"
                    value={value}
                    checked={formData.azPolizei === value}
                    onChange={handleInputChange}
                    className="text-blue-500 focus:ring-blue-400"
                  />
                  <span className="ml-2 font-[700]">{value}</span>
                </label>
              ))}
            </div>
          </div>

          {/* SCHECKHEFT Section */}
          <div className="flex flex-col w-full">
            <label className="font-bold w-full mb-2">SCHECKHEFT</label>
            <div className="flex flex-col md:flex-row space-y-2 md:space-y-0 md:space-x-4">
              {['Nein', 'ja'].map((value) => (
                <label key={value} className="inline-flex items-center">
                  <input
                    type="radio"
                    name="scheckheft"
                    value={value}
                    checked={formData.scheckheft === value}
                    onChange={handleInputChange}
                    className="text-blue-500 focus:ring-blue-400"
                    autocomplete="off"
                  />
                  <span className="ml-2 font-[700]">{value}</span>
                </label>
              ))}
            </div>
          </div>

          {/* HINWEISEN Section */}
          <div className="flex flex-col w-full">
            <label className="font-bold w-full mb-2">HINWEISEN AUF RB, NA, 6 MONATE</label>
            <textarea
              name="oneNote"
              value={formData.oneNote}
              onChange={handleInputChange}
              required
              className="w-full rounded-md p-2 focus:outline-none border border-gray-300 bg-[#c8e8ef] resize-none"
              rows="3"
              autocomplete="off"
            ></textarea>
          </div>

          {/* BEMERKUNGEN Section */}
          <div className="flex flex-col w-full">
            <label className="font-bold w-full mb-2">BEMERKUNGEN</label>
            <textarea
              name="oneComment"
              value={formData.oneComment}
              onChange={handleInputChange}
              required
              className="w-full rounded-md p-2 focus:outline-none border border-gray-300 bg-[#c8e8ef] resize-none"
              rows="3"
              autocomplete="off"
            ></textarea>
          </div>

          {/* Signature Section */}
          <div className="block pt-4 pb-4">
            <h1 className="text-center font-bold mb-4">Abtretungserklärung Unterschreiben</h1>
            <div className="flex justify-center">
              <div className="w-full md:w-[350px] h-[100px] border border-gray-300 bg-[#c8e8ef] rounded-lg">
                <ReactSignatureCanvas
                  canvasProps={{ className: "w-full h-full" }}
                  ref={(data) => setSign(data)}
                />
              </div>
            </div>
            <div className="flex justify-center space-x-4 mt-4">
              <button
                onClick={handelClear}
                type='button'
                className="text-[rgb(255,140,0)]"
              >
                <FaRepeat className="text-2xl"/>
              </button>
              <button
                type='button'
                onClick={handelGenerate}
                className="text-[rgb(255,140,0)]"
              >
                <FaCheck className="text-2xl"/>
              </button>
            </div>
          </div>

          {/* Submit Button */}
          <div className="flex justify-center pb-8">
            <button 
              className="bg-[rgb(255,140,0)] text-white px-8 py-2 rounded-md w-full md:w-auto"
              onClick={handleNext} 
              disabled={createLoading} 
            >
              {createLoading ? <ClipLoader size={20} color="#fff" /> : "Send"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}


export default AddInfoAuftrag
